function testIdGen(value) {
    return String(value).trim().replace(/\s+/g, "-").toLowerCase();
}

export { testIdGen };
//# sourceMappingURL=testIdGen.esm.js.map
